import { Avatar, IconButton, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import { action, observable, runInAction, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import MinutaApi from '../../api/MinutaApi';
import Modal from '../../misc/Modal';
import { EnumOrigemProcesso } from '../../modelo';
import { Peca } from '../../modelo/dominio/Peca';
import { DadosProcessoDto } from '../../modelo/dto/DadosProcessoDto';
import { PeticaoPendente } from '../../modelo/PeticaoApreciada';
import FiltroStore from '../../store/FiltroStore';
import MensagemStore from '../../store/MensagemStore';
import ParametroStore from '../../store/ParametroStore';
import ProcessoExpandidoStore from '../../store/ProcessoExpandidoStore';
import ProcessoStore from '../../store/ProcessoStore';
import UsuarioStore from '../../store/UsuarioStore';
import './css/Triagem.css';
import SituacaoPeca from './SituacaoPeca';

interface IPropsModalSituacaoPeca {
    dadosProcesso?: DadosProcessoDto,
    peca: Peca
}


class ModalSituacaoPeca extends React.Component<IPropsModalSituacaoPeca> {
    modalAberto = false;
    codigoSituacaoStatus = this.props.peca.codigoPeticaoStatus;
    descricaoSituacaoStatus = this.props.peca.descricaoPeticaoStatus;

    constructor(props: IPropsModalSituacaoPeca) {
        super(props);

        makeObservable(this, {
            modalAberto: observable,
            codigoSituacaoStatus: observable,
            descricaoSituacaoStatus: observable,
            abrirModal: action,
            fecharModal: action,
            handleSituacaoPeca: action,
            salvar: action
        });
    }

    get peca(): Peca {
        return this.props.peca;
    }

    abrirModal = () => {
        if (ProcessoExpandidoStore.dadosProcesso.relator.sigla === UsuarioStore.localizacao.siglaOrgaoJulgador) {
            this.modalAberto = true;
        } else {
            MensagemStore.apresentarInformacao('Este gabinete não é relator do processo, portanto não pode mudar situação.');
        }
    };

    fecharModal = () => {
        this.modalAberto = false;
    };


    handleSituacaoPeca = (descricaoSituacao: string) => {
        this.descricaoSituacaoStatus = descricaoSituacao;
    };

    salvar = async () => {
        this.modalAberto = false;
        const situacaoPeticao = ParametroStore.situacoesPeticao.find(situacaoPeticao => situacaoPeticao.descricao == this.descricaoSituacaoStatus);
        const numeroPeticao = this.props.peca.numPeticao + '';
        const numero = numeroPeticao.substring(0, numeroPeticao.indexOf('/'));
        const ano = numeroPeticao.substring(numeroPeticao.indexOf('/') + 1, numeroPeticao.indexOf('-'));

        const processoStore = ProcessoStore._processos.find(processoStore => {
            if (processoStore.identificadorProcesso == this.props.peca.idProcesso) {
                return processoStore;
            }
        });

        if (this.isOrigemEsij) {
            MinutaApi.alterarSituacoesPeticao(this.props.peca.idProcesso, numero + '-' + ano, situacaoPeticao).then(() => {
                MensagemStore.apresentarMensagem('Situação da peça salva.');

                runInAction(() => {
                    if ((this.props.peca?.codigoPeticaoStatus == 6 || this.props.peca?.codigoPeticaoStatus == 7)
                        && !(situacaoPeticao.codigo == 6 || situacaoPeticao.codigo == 7)) {

                        const peticaoPendente = new PeticaoPendente();
                        peticaoPendente.idUnico = this.props?.peca.numPeticao.toString().substring(0, this.props?.peca.numPeticao.toString().length - 2);
                        peticaoPendente.juntadoEm = this.props?.peca.juntadoEm;
                        peticaoPendente.numeroPeticao = this.props?.peca.id;
                        peticaoPendente.numeroProcesso = this.props?.peca.idProcesso;
                        peticaoPendente.situacaoPeticao = this.props?.peca.descricaoPeticaoStatus;
                        peticaoPendente.titulo = this.props?.peca.titulo;

                        processoStore.peticoesPendentes.push(peticaoPendente);

                        this.props.peca.peticaoNaoLida = true;
                    } else if ((this.props.peca?.codigoPeticaoStatus != 6 && this.props.peca?.codigoPeticaoStatus != 7)
                        && (situacaoPeticao.codigo == 6 || situacaoPeticao.codigo == 7)) {

                        processoStore.peticoesPendentes = processoStore.peticoesPendentes.filter(peticao => peticao.numeroPeticao != this.props?.peca.id);
                        this.props.peca.peticaoNaoLida = false;
                    }

                    this.props.peca.codigoPeticaoStatus = situacaoPeticao.codigo;
                    this.props.peca.descricaoPeticaoStatus = situacaoPeticao.descricao;

                    FiltroStore.procurar(false, false);
                });
            }).catch((erro) => {
                MensagemStore.apresentarErro('Não foi possível salvar a situação da peça. Erro: ' + erro)
            });
        } else {
            if (situacaoPeticao.descricao == 'Apreciada') {
                MinutaApi.apreciarPeticao(this.props.peca.idProcesso, this.props.peca.id).then(() => {
                    MensagemStore.apresentarMensagem('Situação da peça salva.');

                    runInAction(() => {
                        if (this.props.peca.descricaoPeticaoStatus != 'Apreciada') {
                            processoStore.peticoesPendentes =
                                processoStore.peticoesPendentes.filter(peticao => peticao.idUnico != this.props?.peca.idUnicoDocumento);

                            this.props.peca.peticaoNaoLida = false;
                        }

                        this.props.peca.descricaoPeticaoStatus = 'Apreciada';

                        processoStore.peticoesPendentes =
                            processoStore.peticoesPendentes.filter(peticao => peticao.idUnico != this.props?.peca.idUnicoDocumento);

                        FiltroStore.procurar(false, false);
                    });
                });
            } else {
                MinutaApi.desapreciarPeticao(this.props.peca.idProcesso, this.props.peca.id).then(() => {
                    MensagemStore.apresentarMensagem('Situação da peça salva.');

                    runInAction(() => {
                        if (this.props.peca.descricaoPeticaoStatus != 'Não apreciada') {
                            this.props.peca.peticaoNaoLida = true;
                        }

                        this.props.peca.descricaoPeticaoStatus = 'Não apreciada';

                        const peticaoPendente = new PeticaoPendente();
                        peticaoPendente.idUnico = this.props?.peca.idUnicoDocumento;
                        peticaoPendente.juntadoEm = this.props?.peca.juntadoEm;
                        peticaoPendente.numeroPeticao = this.props?.peca.numPeticao;
                        peticaoPendente.numeroProcesso = this.props?.peca.idProcesso;
                        peticaoPendente.situacaoPeticao = this.props?.peca.descricaoPeticaoStatus;
                        peticaoPendente.titulo = this.props?.peca.titulo;

                        processoStore.peticoesPendentes.push(peticaoPendente);

                        FiltroStore.procurar(false, false);
                    });
                });
            }
        }
    };

    get isOrigemEsij() {
        if (ProcessoExpandidoStore?.dadosProcesso?.origem === EnumOrigemProcesso.LEGADO ||
            this.props.dadosProcesso?.origem === EnumOrigemProcesso.LEGADO) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <>
                <Tooltip title={this.props.peca.descricaoPeticaoStatus}>
                    <IconButton onClick={this.abrirModal}>
                        <Avatar sx={{ width: 24, height: 24, bgcolor: grey[900], fontWeight: 'bold', color: grey[50] }} variant="rounded" >S</Avatar>
                    </IconButton>
                </Tooltip>
                {this.modalAberto &&
                    <Modal aberto={this.modalAberto}
                        fecharModal={this.fecharModal}
                        titulo='Situação da peça'
                        funcaoAcaoSecundaria={this.fecharModal}
                        labelAcaoSecundaria='Descartar'
                        funcaoAcaoPrimaria={this.salvar}
                        labelAcaoPrimaria='Salvar'
                        maxWidth='md'
                        fullWidth
                    >
                        <SituacaoPeca dadosProcesso={this.props.dadosProcesso} peca={this.props.peca} handleSituacaoPeca={this.handleSituacaoPeca} />
                    </Modal>
                }
            </>
        );
    }
}

export default observer(ModalSituacaoPeca);
